<template>
  <div>
    <div
      class="luckyModel"
      v-if="isShowLuckying || isShowLuckyList || isShowWinningList"
    >
      <div class="lucky-close">
        <span class="icontemp stemp-close" @click="close()"></span>
      </div>
      <div class="lucky-winner-list">
        <div v-if="isShowLuckying || isShowLuckyList">
          <div class="lucky-award-name">{{ luckyName }}</div>
          <div class="lucky-wenzi">
            <img
              :src="
                luckyImageUrl || require('../../assets/images/luckyDrow.jpg')
              "
              class="lucky-im"
            />
          </div>
          <div class="lucky-title">{{ awardName }}</div>
          <div class="lucky-box">
            <div class="lucky-award"></div>
            <div class="lucky-content">
              <div class="lucky-ctent">
                <!--抽奖中开始-->
                <div class="lucky-ing" v-if="isShowLuckying">
                  抽奖进行中
                </div>
                <div class="lucky-ing-roll" v-if="isShowLuckying">
                  <img src="../../assets/images/roll.gif" alt="" />
                </div>
                <!--抽奖中开始-->

                <!--抽奖结果开始-->
                <div class="lucky-ing" v-if="isShowLuckyList">
                  {{ isWinner ? "恭喜您中奖了" : "很遗憾您没中奖" }}
                </div>
                <div class="winner-list" v-if="isShowLuckyList">
                  <div
                    class="winner-item"
                    v-for="(p, i) in winnerList"
                    :key="i"
                  >
                    {{ p.showName }}
                  </div>
                </div>
              </div>
            </div>
            <p class="lucky-remind">
              {{ message }}
            </p>
          </div>
        </div>

        <div class="lucky-box" v-if="isShowWinningList">
          <div class="lucky-content">
            <div class="lucky-award"></div>
            <div class="lucky-ctent w-list">
              <!--抽奖中开始-->
              <div class="item" v-for="(l, i) in luckyList" :key="i">
                <div class="name">{{ l.name }}</div>
                <div class="img">
                  <img
                    :src="
                      l.image || require('../../assets/images/luckyDrow.jpg')
                    "
                    alt=""
                  />
                </div>
                <div class="award">{{ l.awardName }}</div>
                <div class="list">
                  <div v-for="(w, i) in l.members" :key="i">
                    {{ w.showName }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  buildLotteryData,
  buildTableMethod,
  mounted
} from "../../common/lottery";
export default {
  name: "Lottery",
  data() {
    return buildLotteryData({});
  },
  created() {},
  methods: buildTableMethod({}),
  mounted() {
    return mounted(this);
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
